// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3ZQPODv9oKaQPNExEP31Au .form-group {\n  width: 50%;\n}\n\n._3KHDgyAGfXDt3x8iz45KXm {\n  margin-top: 0;\n  text-align: center;\n}\n\n._3Oq5YTGtXCqtIy-ZJTSRck {\n  padding-left: 20px;\n}\n\n._3Oq5YTGtXCqtIy-ZJTSRck .table {\n  margin-bottom: 0;\n}", ""]);
// Exports
exports.locals = {
	"form": "_3ZQPODv9oKaQPNExEP31Au",
	"header": "_3KHDgyAGfXDt3x8iz45KXm",
	"timeplanDetails": "_3Oq5YTGtXCqtIy-ZJTSRck"
};
module.exports = exports;
